const API_ORIGIN = 'https://api.sc9.cn';

export const DEFAULT_SITE_TITLE = 'GEO营销系统';

export type SiteBranding = {
  site_name?: string;
  site_logo?: string;
  site_favicon?: string;
  icp?: string;
  copyright?: string;
};

export const withApiOrigin = (url?: string) => {
  const val = String(url || '').trim();
  if (!val) return '';
  if (/^https?:\/\//i.test(val)) return val;
  return `${API_ORIGIN}${val.startsWith('/') ? '' : '/'}${val}`;
};

export const defaultSidebarBrandSrc = () => '/icons/banner_left.png';

export const defaultSiteFaviconSrc = () => '/favicon.ico';

export const readStoredSiteBranding = (): SiteBranding => {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem('siteSetting') : null;
    if (!raw) return {};
    return JSON.parse(raw) as SiteBranding;
  } catch {
    return {};
  }
};

export const persistSiteBranding = (patch: SiteBranding) => {
  if (typeof window === 'undefined') return;
  const base = readStoredSiteBranding();
  localStorage.setItem('siteSetting', JSON.stringify({ ...base, ...patch }));
};

export const resolveSidebarBrandSrc = (branding?: SiteBranding) => {
  const custom = String(branding?.site_logo ?? readStoredSiteBranding().site_logo ?? '').trim();
  if (custom) return withApiOrigin(custom);
  return defaultSidebarBrandSrc();
};

/** 是否使用用户上传的站点 Logo（默认 banner 不参与 1:1 方图适配） */
export const hasCustomSiteLogo = (branding?: SiteBranding) => {
  return !!String(branding?.site_logo ?? readStoredSiteBranding().site_logo ?? '').trim();
};

export const resolveSiteDocumentTitle = (branding?: SiteBranding) => {
  const name = String(branding?.site_name ?? readStoredSiteBranding().site_name ?? '').trim();
  return name || DEFAULT_SITE_TITLE;
};

export const resolveSiteFaviconSrc = (branding?: SiteBranding) => {
  const custom = String(branding?.site_favicon ?? readStoredSiteBranding().site_favicon ?? '').trim();
  if (custom) return withApiOrigin(custom);
  return defaultSiteFaviconSrc();
};

/** 将站点名称与标签页图标写入 document（有 site_name 时全站标签页标题统一为 site_name） */
export const applySiteBrandingToDocument = (branding?: SiteBranding) => {
  if (typeof document === 'undefined') return;

  const merged: SiteBranding = { ...readStoredSiteBranding(), ...branding };
  document.title = resolveSiteDocumentTitle(merged);

  const href = resolveSiteFaviconSrc(merged);
  ['icon', 'shortcut icon'].forEach((rel) => {
    let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement('link');
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = href;
    if (href.endsWith('.svg')) {
      link.type = 'image/svg+xml';
    } else {
      link.removeAttribute('type');
    }
  });
};
